/* import __COLOCATED_TEMPLATE__ from './field-error.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();